export const heroImage = 'https://cdn.magicpatterns.com/uploads/uJ1rwuryuqsomm9gEqABJU/Sistema_de_Entrenamiento_Voleibol_360-Photoroom.webp';

/** Payment link used by every checkout button (the hero button scrolls to the offer instead). */
export const checkoutUrl = 'https://voleyball-360-ready.impultienda.ar/checkout';
export const brandName = 'VOLLEYBALL 360 READY™';
export const price = '$27';
export const regularPrice = '$97';

/** Sent with every InitiateCheckout event. */
export const checkoutPixelParams = {
  content_name: 'Volleyball 360 Ready',
  value: 27,
  currency: 'USD'
};
export interface Stat {
  value: string;
  label: string;
}
export const stats: Stat[] = [{
  value: '6',
  label: 'Visual coaching volumes'
}, {
  value: '72',
  label: 'Ready-to-run practices'
}, {
  value: '5',
  label: 'Practical bonuses'
}];
export const heroBadges: string[] = ['100% in English', 'Instant access', 'Downloadable PDF', '7-day guarantee'];
export interface Testimonial {
  quote: string;
  role: string;
  country: string;
}
export const testimonials: Testimonial[] = [{
  quote: 'The visual progressions make practice planning much easier. I can see exactly how to build each skill step by step.',
  role: 'Youth Volleyball Coach',
  country: 'United States'
}, {
  quote: 'I stopped wasting time searching for drills. Now I can open the system and have a clear plan in minutes.',
  role: 'Club Volleyball Coach',
  country: 'Australia'
}, {
  quote: 'Simple, visual, and very practical. My players get more touches and spend less time waiting.',
  role: 'School Volleyball Coach',
  country: 'United Kingdom'
}];

/** The 6:00 PM scene in the problem section. */
export const arrivalLines: string[] = ['Your players are arriving.', 'Different levels.', 'Different technical needs.', 'Limited gym space.', 'Limited equipment.', 'Limited preparation time.'];
export const sessionLines: string[] = ['One drill is too easy.', 'Another creates long lines.', 'Some players barely touch the ball.', 'The progression is unclear.', 'You see technical mistakes but improvise the correction.', 'The advanced players get bored.', 'The beginners get lost.'];

/** The real cost of not having the right system. */
export type CostIcon = 'clock' | 'repeat' | 'hourglass' | 'route' | 'alert' | 'users' | 'eye';
export interface Cost {
  title: string;
  detail: string[];
  icon: CostIcon;
  /** Accent tint for the card. */
  color: string;
}
export const costs: Cost[] = [{
  icon: 'clock',
  color: '#ea580c',
  title: 'Hours of planning',
  detail: ['Your free time disappears before practice even starts.']
}, {
  icon: 'repeat',
  color: '#7c3aed',
  title: 'Same drills every week',
  detail: ['Players repeat activities without a clear development pathway.']
}, {
  icon: 'hourglass',
  color: '#d97706',
  title: 'Too much waiting',
  detail: ['One player works while the rest stand in line.']
}, {
  icon: 'route',
  color: '#2563eb',
  title: 'No real progression',
  detail: ['You have drills, but not a coaching pathway.']
}, {
  icon: 'alert',
  color: '#dc2626',
  title: 'Improvised corrections',
  detail: ['You see the mistake but are not always sure what to change next.']
}, {
  icon: 'users',
  color: '#0d9488',
  title: 'Mixed-level chaos',
  detail: ['Some players need more challenge.', 'Others need a simpler version.']
}, {
  icon: 'eye',
  color: '#db2777',
  title: 'Too much talking',
  detail: ['Players need to see the action, not listen to a five-minute explanation.']
}];
export const finalCost = {
  title: 'Every practice starts from zero',
  lead: 'And the same question comes back:',
  question: '“What am I going to coach today?”'
};

/** Offer card: everything included in the access. */
export const offerIncluded: string[] = ['72 ready-to-run volleyball practices', '5 practical coaching bonuses', 'Step-by-step visual instruction', 'Court diagrams', 'Coaching cues', 'Common mistakes', 'Quick fixes', 'Practice progressions', 'Printable coaching tools'];

/** Offer card: what you get, shown above the price button. */
export const included: string[] = ['Step-by-step technique', 'Illustrated volleyball drills', 'Court diagrams', 'Visual progressions', 'Common mistakes + quick fixes', 'READY 60™ practices', 'Small-sided games', 'Mixed-level adaptations', 'Coaching cues', 'Practice timelines', 'Printable coaching tools', 'Instant PDF download'];

/** 100% digital section. */
export const digitalNo: string[] = ['No physical shipping.', 'No app required.', 'No subscription.', 'No video course required.'];
export type DeviceIcon = 'phone' | 'tablet' | 'laptop' | 'computer';
export const devices: {
  label: string;
  icon: DeviceIcon;
}[] = [{
  label: 'Phone',
  icon: 'phone'
}, {
  label: 'Tablet',
  icon: 'tablet'
}, {
  label: 'Laptop',
  icon: 'laptop'
}, {
  label: 'Computer',
  icon: 'computer'
}];

/** Closing: keep improvising vs. use the system. */
export const keepImprovising: string[] = ['Spend hours searching YouTube', 'Save random drills from different websites', 'Repeat the same exercises', 'Build every practice from zero', 'Explain every technique from memory', 'Let players wait in long lines', 'Struggle with mixed-level groups', 'Arrive at the gym still thinking about the plan'];
export const useTheSystem: string[] = ['Plan your practice in minutes', 'Open a complete READY 60™ practice', 'Follow a clear skill progression', 'Use visual setups', 'Use short coaching cues', 'Adapt exercises to your group', 'Increase ball contacts', 'Move from technique to game', 'Arrive ready to coach'];

/** The difference: keep improvising vs. the system. */
export const differenceWithout: string[] = ['Hours searching for drills', 'No clear technical progression', 'Players waiting in lines', 'Mixed-level chaos', 'Too much explanation', 'Random weekly planning', 'Every practice starts from zero'];
export const differenceWith: string[] = ['5 minutes to organize your practice', '72 complete practices ready to use', 'Clear step-by-step progressions', 'More touches, less waiting', 'Visual coaching system', 'Adaptations for different levels', 'Practical coaching cues', 'A repeatable structure for your training week'];